import React from "react";
import { Breadcrumbs, Typography } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

interface BreadcrumbItem {
  label: string;
  onClick?: () => void;
}

interface CommonBreadcrumbProps {
  title: string;
  breadcrumbItems: BreadcrumbItem[];
}

const CommonBreadcrumb: React.FC<CommonBreadcrumbProps> = ({ title, breadcrumbItems }) => {

  return (
    <div className="main_title">
      <div className="title_breadcrumb_content">
        <div className="breadcrumb_wrapper">
          <Breadcrumbs
            separator={<NavigateNextIcon fontSize="small" />}
            aria-label="breadcrumb"
          >
            {breadcrumbItems.map((item, index) => {
              const isLast = index === breadcrumbItems.length - 1;
              return isLast ? (
                <Typography key={index} className="last_breadcrumb">
                  {item.label}
                </Typography>
              ) : (
                <button
                  key={index}
                  className="breadcrumb_link"
                  onClick={item.onClick}
                >
                  {item.label}
                </button>
              );
            })}
          </Breadcrumbs>
        </div>
        <h1>{title}</h1>
      </div>
    </div>
  );
};

export default CommonBreadcrumb;
